import { CalendarMonth, Person } from "@mui/icons-material";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Chip,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

const BlogsCard = ({ blog }) => {
  if (!blog) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Extract a short excerpt from the content
  const createExcerpt = (htmlContent, maxLength = 120) => {
    if (!htmlContent) return "";

    // Create a temporary element to parse HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    // Get text content
    const textContent = tempDiv.textContent || tempDiv.innerText || "";

    // Truncate and add ellipsis if needed
    return textContent.length > maxLength
      ? textContent.substring(0, maxLength) + "..."
      : textContent;
  };

  return (
    <Card
      elevation={2}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
        },
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <CardActionArea LinkComponent={Link} to={`/blog/${blog.slug}`}>
        <CardMedia
          component="img"
          height="200"
          image={
            blog.coverImage ||
            blog.bannerImage ||
            "/placeholder.svg?height=200&width=400"
          }
          alt={blog.title}
          sx={{ objectFit: "cover" }}
        />

        <CardContent
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ mb: 1, display: "flex", gap: 1 }}>
            {blog.categories && blog.categories.length > 0 && (
              <Chip
                label={blog.categories[0].categoryName || blog.categories[0]}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ borderRadius: "4px" }}
              />
            )}
          </Box>

          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 600,
              mb: 1,
              lineHeight: 1.3,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {blog.title}
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              mb: 2,
              color: "text.secondary",
              fontSize: "0.8rem",
            }}
          >
            {blog.createdAt && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <CalendarMonth fontSize="small" />
                {formatDate(blog.createdAt)}
              </Box>
            )}
            {blog.author && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Person fontSize="small" />
                {blog.author}
              </Box>
            )}
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mb: 2,
              flexGrow: 1,
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {blog.excerpt || createExcerpt(blog.content)}
          </Typography>

          {/* <Button
            component={Link}
            to={`/${blog.slug}`}
            variant="outlined"
            color="primary"
            size="small"
            sx={{
              alignSelf: "flex-start",
              borderRadius: "4px",
              textTransform: "none",
            }}
          >
            Read More
          </Button> */}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default BlogsCard;
